import { render, staticRenderFns } from "./TabSulfuric.vue?vue&type=template&id=2a42ec12&"
import script from "./TabSulfuric.vue?vue&type=script&lang=js&"
export * from "./TabSulfuric.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports